<template>
  <div class="dropdown-menu" :style="cssVars" ref="menu">
    <button
      class="dropdown-menu___button button_margin_removed"
      :class="{ active: menuExpanded }"
      @click="toggleMenu()"
    >
      Menu
    </button>
    <nav class="dropdown-menu__nav" :class="{ visible: menuExpanded }">
      <ul class="dropdown-menu__items">
        <li
          v-for="menu in menuItems"
          :key="menu.name"
          class="dropdown-menu__item text"
        >
          <a
            class="dropdown-menu__link  button_margin_removed rounded"
            @click="updateTab(menu.name)"
          >
            {{ menu.name }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mobileContentList } from '@/contents/contents.js'
export default {
  data() {
    return {
      menuExpanded: false,
      menuItems: mobileContentList
    }
  },
  computed: {
    cssVars() {
      return {
        '--height': window.screen.availHeight
      }
    }
  },
  methods: {
    toggleMenu: function() {
      this.menuExpanded = !this.menuExpanded
    },
    updateTab: function(tab) {
      this.$emit('navUpdated', tab)
      this.menuExpanded = !this.menuExpanded
    }
  },
  mounted: function() {}
}
</script>

<style scoped>
html,
body {
  height: 100%;
}
.dropdown-menu {
  position: fixed;
  width: 100%;
  height: -webkit-fill-available;
  height: -moz-available;
  height: fill-available;
  display: flex;
  flex-direction: column;
  top: calc(100% - 10vh);
  z-index: 20;
}
.dropdown-menu__nav {
  height: calc(100% - 10vh);
  width: 100%;
  margin: 0;
  transition: all 0.4s ease-in-out;
}
.dropdown-menu__nav.visible {
  transform: translateY(calc(-100%));
  bottom: 10vh;
}
.dropdown-menu__items {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.dropdown-menu__item {
  display: block;
  width: 100%;
  flex-grow: 2;
  flex: 1 1 3.2rem;
  display: grid;
  place-items: center;
  -webkit-text-fill-color: #f8f8f8;
  color: var(--bg-color);
}
a.dropdown-menu__link {
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
  -webkit-text-fill-color: #f8f8f8;
  color: var(--bg-color);
  background: var(--primary-color);
  display: grid;
  place-items: center;
  border: 0.1rem solid var(--bg-color);
  font-weight: 400;
  font-style: normal;
  z-index: 20;
}
.dropdown-menu___button.button_margin_removed {
  height: 10vh;
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 10;
}
.dropdown-menu___button.active {
  border: 0.1rem solid var(--primary-color);
  color: var(--primary-color);
  background: var(--bg-color);
}
</style>
